import type { SxProps, Theme } from '@mui/material';

export const revealedCardRootSx: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const revealedCardImageWrapperSx: SxProps<Theme> = {
  width: '100%',
  aspectRatio: '300 / 527',
  backgroundColor: 'background.default',
  overflow: 'hidden',
};

export const revealedCardImageSx = (isReversed: boolean): SxProps<Theme> => ({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  display: 'block',
  transform: isReversed ? 'rotate(180deg)' : 'none',
});

export const revealedCardPositionSx: SxProps<Theme> = {
  display: 'block',
  mb: 1,
};

export const revealedCardTitleSx: SxProps<Theme> = {
  mb: 1,
};

export const revealedCardChipSx: SxProps<Theme> = {
  mr: 1,
  mb: 1,
};

export const revealedCardInfoBoxSx: SxProps<Theme> = {
  mt: 2,
};

export const revealedCardOrientationLabelSx: SxProps<Theme> = {
  mb: 1,
};

export const revealedCardBodyTextSx: SxProps<Theme> = {
  mb: 2,
};
